import modalState from './modal-state';
import { getInitData } from 'packages/init-data';

const initData = getInitData() || {};
let isAutoStartAllowed = initData.pageSpecificData
    ? initData.pageSpecificData.isAutoStartAllowed
    : false;

export default {
    isFetching: false,
    errorMessage: null,
    modalState: modalState.CLOSED,
    autoStartToken: null,
    onCompleteCallback: null,
    onCloseCallback: null,
    isAutoStartAllowed
};
